import * as React from "react";
import { UitkUnformattedHtml, UitkUnformattedHtmlReplaceDefaults } from "uitk-react-unformatted-html";
import { UitkHeading } from "uitk-react-text";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing } from "uitk-react-spacing";

type DecorateEditorialHtmlProps = { text: string | undefined };

export const DecorateEditorialHtml: React.FC<DecorateEditorialHtmlProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  return (
    <>
      <UitkUnformattedHtml
        elementsToReplace={{
          ...UitkUnformattedHtmlReplaceDefaults,
          h1: ({ children, ...props }) => (
            <UitkHeading {...props} size={4}>
              {children}
            </UitkHeading>
          ),
          h2: ({ children, ...props }) => (
            <UitkHeading {...props} size={4}>
              {children}
            </UitkHeading>
          ),
          h3: ({ children, ...props }) => (
            <UitkHeading {...props} size={6}>
              {children}
            </UitkHeading>
          ),
          h4: ({ children, ...props }) => (
            <UitkHeading {...props} size={6}>
              {children}
            </UitkHeading>
          ),
          h5: ({ children, ...props }) => (
            <UitkHeading {...props} size={5}>
              {children}
            </UitkHeading>
          ),
          h6: ({ children, ...props }) => (
            <UitkHeading {...props} size={5}>
              {children}
            </UitkHeading>
          ),
          li: ({ children, ...props }) => <UitkListItem {...props}>{children}</UitkListItem>,
          ul: ({ children, ...props }) => (
            <UitkSpacing margin={{ block: "two" }}>
              <UitkList {...props}>{children}</UitkList>
            </UitkSpacing>
          ),
          ol: ({ children, ...props }) => (
            <UitkSpacing margin={{ block: "two" }}>
              <UitkList {...props} type="ordered">
                {children}
              </UitkList>
            </UitkSpacing>
          ),
        }}
        htmlToParse={text}
        plainTextElement={({ children }) => <p>{children}</p>}
      />
    </>
  );
};

/** Extracts the citiCode
 * @returns {string} citiCode if present in the current path, otherwise empty string
 */
export const returnCitiCode = (searchUrl: string) => {
  const INITIAL_INDEX = searchUrl.indexOf("citiCode") + 9; //to get citiCode value's beginning index in the searchUrl
  const FINAL_INDEX = searchUrl.indexOf("citiCode") + 12; //to get citiCode value's final index in the searchUrl
  return searchUrl.includes("citiCode") ? searchUrl.substring(INITIAL_INDEX, FINAL_INDEX) : "";
};
